export default defineNuxtRouteMiddleware(async (to) => {
  const cartId = useCookie('cartId', {
    maxAge: 2592000,
  })
  const cart = useCartStore()

  if (!cartId.value) {
    cart.data = null
    return
  }

  await cart.fetch()

  // A fixture that must be sold with a hotel is completed on its own step, and
  // until it has one the cart is a way to pay for the ticket alone — so the cart
  // sends the customer back to finish the package (BOAT-1755).
  //
  // Once the stay is in, the package is done and the cart is theirs again: they
  // may well be adding another match to the same basket, and bouncing them back
  // here would trap them. Dropping the hotel is already impossible — the cart
  // hides its remove control for a mandatory stay.
  //
  // What makes the package finished is the fixture being paired with a stay, not
  // the basket holding a hotel: a stay picked from the cart before the fixture
  // was added belongs to nobody, and counting it let the fixture through without
  // a package of its own.
  const isCartRoute = /(^|\/)cart$/.test(to.path)
  const needsHotel =
    cart.data?.items.some((item) => item.mandatoryHotel && !item.packageId) ?? false

  if (isCartRoute && needsHotel) {
    return navigateTo('/package/hotel')
  }
})
